import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';

function CreateModal({
  createLandClassification,
  getLandClassificationsList,
  history,
  getSingleLandClass,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
    };
    createLandClassification(args, ({ data }) => {
      setModal({ isOpen: false });
      getLandClassificationsList({isPaginate: 1});
      history.push(
        `/rpt/land/land-settings/land-classification/${_.get(data, 'id')}`
      );
      getSingleLandClass(data.id);
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button 
            type="submit" 
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  createLandClassification: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
